import React from "react";
import { RxCounterClockwiseClock } from "react-icons/rx";
import ScrollAnimation from 'react-animate-on-scroll';

import SpDecor from '../../img/decor/sp_decor.png';

import Sp_1 from '../../img/program-preview/sp_1.webp'
import Sp_2 from '../../img/program-preview/sp_2.webp'

import Sp_logo_1 from '../../img/program-preview/sp_logo_1.webp'
import Sp_logo_2 from '../../img/program-preview/sp_logo_2.webp'


const speakers = [
    {
        name: "Анастасія Кузьменко",
        position: "керівниця освітнього проєкту 1+1 media school",
        logo: Sp_logo_1,
        image: Sp_1,
    },
    {
        name: "Марія Абдулліна",
        position: "керівниця платформи OLX Робота, співголова HR-комітету Європейської Бізнес Асоціації",
        logo: Sp_logo_2,
        image: Sp_2,
    },
];

function  EventProgramPreview() {
    return (
        <section id="programm" className="mb-16 lg:mb-[120px]">
            <div className="container max-w-screen-xl mx-auto px-4">
                <div className="mb-8 lg:mb-14">
                    <h2 className="text-center font-bold uppercase text-3xl text-[#000] mb-6 sm:text-4xl lg:text-[60px]">Програма 2026</h2>
                    <p className="text-[#adadad] mb-9 md:mb-14 font-normal text-center">
                        *Програма заходу та порядок виступів можуть змінюватися. Слідкуйте за оновленнями!
                    </p>
                    <div className="py-3 px-5 mb-4 bg-[#c8d2db]">
                        <div className="flex flex-wrap items-center gap-x-3 md:gap-5 md:flex-nowrap lg:text-xl">
                            <RxCounterClockwiseClock className="text-[#000]"/>
                            <span>09:00 – 09:40</span>
                            <h4 className="flex-[100%] md:flex-1 font-bold ">Реєстрація та велкам-кава від Foundation Coffee Roasters</h4>
                        </div>
                    </div>
                    <div className="py-3 px-5 mb-4 bg-[#c8d2db]">
                        <div className="flex flex-wrap items-center gap-x-3 md:gap-5 md:flex-nowrap lg:text-xl">
                            <RxCounterClockwiseClock className="text-[#000]"/>
                            <span>09:40 – 10:00</span>
                            <h4 className="flex-[100%] md:flex-1 font-bold ">Вітальне слово ведучої та організаторів </h4>
                        </div>
                    </div>
                    <div>
                        <div className="py-3 px-5 mb-4 bg-[#c8d2db]">
                            <div className="flex flex-wrap items-center gap-x-3 md:gap-5 md:flex-nowrap lg:text-xl">
                                <RxCounterClockwiseClock className="text-[#000]"/>
                                <span>10:00 – 14:20</span>
                                <h4 className="flex-[100%] md:flex-1 font-bold">Перша частина. Панельні дискусії:</h4>
                            </div>
                        </div>
                        <div className="pl-3 lg:pl-8 mb-7 lg:mb-10">
                            <h3 className="font-bold lg:text-xl  mb-4">Кадровий тиск і нова логіка рішень у бізнесі</h3>
                            <ul>
                                <li className="flex gap-2 items-center mb-2"><div class="w-2 h-2 flex-shrink-0 bg-[#2F8F83] rounded-full"></div>
                                У якому стані наразі перебуває ринок праці в Україні?</li>
                                <li className="flex gap-2 items-center mb-2"><div class="w-2 h-2 flex-shrink-0 bg-[#2F8F83] rounded-full"></div>
                                Як змінилася демографічна ситуація та як ці зміни впливають на наявність фахівців? </li>
                                <li className="flex gap-2 items-center"><div class="w-2 h-2 flex-shrink-0 bg-[#2F8F83] rounded-full"></div>
                                Як нестача робочих рук спонукає бізнес переглядати свою кадрову політику та змінювати пріоритети щодо статі, віку та досвіду майбутніх працівників?</li>
                            </ul>
                        </div>
                        <div className="pl-3 lg:pl-8 mb-7 lg:mb-10">
                            <h3 className="font-bold lg:text-xl  mb-4">Нові компетенції і швидкість появи професій</h3>
                            <ul>
                                <li className="flex gap-2 items-center mb-2"><div class="w-2 h-2 flex-shrink-0 bg-[#2F8F83] rounded-full"></div>
                                Які професії, що виникли протягом останніх 3–5 років, є дефіцитними для бізнесу?</li>
                                <li className="flex gap-2 items-center mb-2"><div class="w-2 h-2 flex-shrink-0 bg-[#2F8F83] rounded-full"></div>
                                Чи вдається компаніям готувати нових експертів із власних працівників?</li>
                                <li className="flex gap-2 items-center"><div class="w-2 h-2 flex-shrink-0 bg-[#2F8F83] rounded-full"></div>
                                Де шукати фахівців, яких ще не готує система освіти, та як пришвидшити її реакцію на нові виклики?</li>
                            </ul>
                        </div>
                        <div className="pl-3 lg:pl-8 mb-7 lg:mb-10">
                            <h3 className="font-bold lg:text-xl  mb-4">Роботодавець як система: довіра, управління і стабільність команд</h3>
                            <ul>
                                <li className="flex gap-2 items-center mb-2"><div class="w-2 h-2 flex-shrink-0 bg-[#2F8F83] rounded-full"></div>
                                Успішні практики та підходи до управління людьми</li>
                                <li className="flex gap-2 items-center mb-2"><div class="w-2 h-2 flex-shrink-0 bg-[#2F8F83] rounded-full"></div>
                                Правила, які дозволили компаніям розвинути та зміцнити бренд надійного роботодавця</li>
                                <li className="flex gap-2 items-center"><div class="w-2 h-2 flex-shrink-0 bg-[#2F8F83] rounded-full"></div>
                                Стратегії, які допомагають сильним брендам уникати кадрових криз або швидко реагувати на них</li>
                            </ul>
                        </div>
                        <div className="pl-3 lg:pl-8 mb-7 lg:mb-10">
                            <h3 className="font-bold lg:text-xl  mb-4">HR як функція впливу: рішення, інструменти, ефективність</h3>
                            <ul>
                                <li className="flex gap-2 items-center mb-2"><div class="w-2 h-2 flex-shrink-0 bg-[#2F8F83] rounded-full"></div>
                                Які практики та технології стали ключовими інструментами HR-фахівців у щоденній роботі з персоналом?</li>
                                <li className="flex gap-2 items-center mb-2"><div class="w-2 h-2 flex-shrink-0 bg-[#2F8F83] rounded-full"></div>
                                Яким сьогодні є рецепт збалансованої системи мотивації персоналу?  </li>
                                <li className="flex gap-2 items-center"><div class="w-2 h-2 flex-shrink-0 bg-[#2F8F83] rounded-full"></div>
                                Як діяти в умовах гострої конкуренції за спеціалістів та не допускати відтоку кадрів до конкурентів? </li>
                                 <li className="flex gap-2 items-center"><div class="w-2 h-2 flex-shrink-0 bg-[#2F8F83] rounded-full"></div>
                                Як розпізнавати таланти та не втрачати працівників, які заслуговують на розвиток та зростання?</li>
                            </ul>
                        </div>
                    </div>
                    <div className="py-3 px-5 mb-4 bg-[#c8d2db]">
                        <div className="flex flex-wrap items-center gap-x-3 md:gap-5 md:flex-nowrap lg:text-xl">
                            <RxCounterClockwiseClock className="text-[#000]"/>
                            <span>14:20 – 15:00</span>
                            <h4 className="flex-[100%] md:flex-1 font-bold ">Перерва та нетворкінг  </h4>
                        </div>
                    </div>
                    <div>
                        <div className="py-3 px-5 mb-4 bg-[#c8d2db]">
                            <div className="flex flex-wrap items-center gap-x-3 md:gap-5 md:flex-nowrap lg:text-xl">
                                <RxCounterClockwiseClock className="text-[#000]"/>
                                <span>10:00 – 14:20</span>
                                <h4 className="flex-[100%] md:flex-1 font-bold">Друга частина. Панельні дискусії:</h4>
                            </div>
                        </div>
                        <div className="pl-3 lg:pl-8 mb-7 lg:mb-10">
                            <h3 className="font-bold lg:text-xl  mb-4">Люди після служби: повернення, інтеграція і робоче середовище</h3>
                            <ul>
                                <li className="flex gap-2 items-center mb-2"><div class="w-2 h-2 flex-shrink-0 bg-[#2F8F83] rounded-full"></div>
                                Які практики адаптації ветеранів виявилися ефективними? </li>
                                <li className="flex gap-2 items-center mb-2"><div class="w-2 h-2 flex-shrink-0 bg-[#2F8F83] rounded-full"></div>
                                Де компанії були змушені вчитися на власних помилках і до яких висновків дійшли?</li>
                                <li className="flex gap-2 items-center"><div class="w-2 h-2 flex-shrink-0 bg-[#2F8F83] rounded-full"></div>
                                Як HR-фахівцям ефективно підтримувати одночасно тих, хто долучається до Сил оборони, і тих, хто повертається до роботи після служби, та не повторювати помилок колег, які вже мають такий досвід?</li>
                            </ul>
                        </div>
                        
                    </div>
                    <div className="py-3 px-5 bg-[#c8d2db]">
                        <div className="flex flex-wrap items-center gap-x-3 md:gap-5 md:flex-nowrap lg:text-xl">
                            <RxCounterClockwiseClock className="text-[#000]"/>
                            <span>18:00</span>
                            <h4 className="flex-[100%] md:flex-1 font-bold ">[Церемонія нагородження найкращих роботодавців та HRD за версією журналу «ТОП-100. Рейтинги найбільших»]</h4>
                        </div>
                    </div>
                </div>
                <div className="bg-[#f1f3f2] py-16 ">
                    <div className="container max-w-screen-xl mx-auto pb-8 px-4">
                        <h2 className="text-center font-bold uppercase text-3xl text-[#000] mb-6 sm:text-4xl lg:text-[60px]">Інсайтами у сольних виступах </h2>
                        <p className="mb-9 md:mb-14 font-normal text-center">на сцені HR Wisdom Summit поділяться:</p>

                        <div className="flex flex-col gap-4 md:flex-wrap md:flex-row">
                            {speakers.map((speaker, index) => {
                                const bgClass =  index % 2 === 0 ? "bg-[#c8d2db]" : "bg-[#e8b500]";
                                return (
                                    <div key={index} className="flex h-64 md:max-w-[30%]">
                                        <div className="w-1/2 flex-shrink-0 flex flex-col justify-center gap-3 bg-white pl-4 lg:pl-5 pr-4">
                                            <h4 className="font-bold uppercase">{speaker.name}</h4>
                                            <p className="font-normal text-[13px]">{speaker.position}</p>
                                            <img src={speaker.logo} className="max-w-[60%]" />
                                        </div>

                                        <div className={`w-1/2 flex-shrink-0 flex flex-col justify-end relative ${bgClass}`}>
                                            <img
                                                src={speaker.image}
                                                className="w-full object-cover -ml-10 relative z-10"
                                            />
                                            <img
                                                className="w-full h-auto absolute bottom-0 right-0"
                                                src={SpDecor}
                                            />
                                        </div>
                                    </div>
                                );
                            })}
                        </div>

                    </div>
                </div>
            </div>
        </section>
    )

}

export default EventProgramPreview;